import type { BinaryReader } from '../BinaryReader';
import type { BinaryWriter } from '../BinaryWriter';
import { GameName, GameState, GameTime, GameWaitState } from '../enums';

/**
 * Mirrors GameStars.Models.NetworkModels.GameInfoModel (CommonNetworkModels.cs:171-222).
 *
 * IMPORTANT: the wire (Serialize) order differs from the C# field-declaration order —
 * GameName is written BEFORE GameState:
 *   UniqueId(string), GameName(short), GameState(short), GameTime(short),
 *   GameWaitState(short), GamePrice(long), GameCount(short), GameType(short).
 * GameType is a per-game variant (HokmType / BackgammonType; 0 for Blackjack).
 */
export interface GameInfoModel {
  uniqueId: string;
  gameName: GameName;
  gameState: GameState;
  gameTime: GameTime;
  gameWaitState: GameWaitState;
  gamePrice: bigint;
  gameCount: number;
  gameType: number;
}

export function decodeGameInfoModel(r: BinaryReader): GameInfoModel {
  return {
    uniqueId: r.getString(),
    gameName: r.getShort() as GameName,
    gameState: r.getShort() as GameState,
    gameTime: r.getShort() as GameTime,
    gameWaitState: r.getShort() as GameWaitState,
    gamePrice: r.getLong(),
    gameCount: r.getShort(),
    gameType: r.getShort(),
  };
}

export function writeGameInfoModel(w: BinaryWriter, g: GameInfoModel): void {
  w.putString(g.uniqueId)
    .putShort(g.gameName)
    .putShort(g.gameState)
    .putShort(g.gameTime)
    .putShort(g.gameWaitState)
    .putLong(g.gamePrice)
    .putShort(g.gameCount)
    .putShort(g.gameType);
}
